import {
    AnyAction,
    CaseReducer,
    createAsyncThunk,
} from '@reduxjs/toolkit'
import {
    NinchatActionType,
    NinchatDescribeFileAction,
} from '../types/actions'
import {
    NinchatFileFoundEvent,
    NinchatMessageReceivedEvent,
} from 'api/types/events'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatState} from 'api/types'

const actionTypePrefix = 'NINCHAT/action'

type DescribeFileAsyncThunkConfig = {
    pendingMeta: {reducer: CaseReducer<NinchatState, DescribeFilePendingAction>}
    rejectedMeta: {reducer: CaseReducer<NinchatState, DescribeFileRejectedAction>}
}
type DescribeFilePendingAction = AnyAction & {meta: {arg: NinchatActionParams<NinchatDescribeFileAction> & MessageReceivedEvent}}
type DescribeFileRejectedAction = AnyAction & {meta: {arg: NinchatActionParams<NinchatDescribeFileAction> & MessageReceivedEvent}}
type MessageReceivedEvent = {event?: NinchatMessageReceivedEvent}

export const describeFile = createAsyncThunk<NinchatFileFoundEvent, NinchatActionParams<NinchatDescribeFileAction> & MessageReceivedEvent, DescribeFileAsyncThunkConfig>(
    `${actionTypePrefix}/${NinchatActionType.NinchatDescribeFileAction}`,
    async (arg, thunkAPI) => {
        const {
            event, // eslint-disable-line @typescript-eslint/no-unused-vars
            ...params
        } = arg

        params.action = NinchatActionType.NinchatDescribeFileAction

        try {
            return await ninchatClient.send(params) as NinchatFileFoundEvent
        } catch (err) {
            return thunkAPI.rejectWithValue(err, {reducer: rejectedDescribeFileReducer}) // eslint-disable-line @typescript-eslint/no-use-before-define
        }
    },
    {getPendingMeta: () => ({reducer: pendingDescribeFileReducer})}, // eslint-disable-line @typescript-eslint/no-use-before-define
)

const pendingDescribeFileReducer: CaseReducer<NinchatState, DescribeFilePendingAction> = (state, action) => {
    const {
        meta: {
            arg: {
                event,
                file_id,
            },
        },
    } = action

    if (event) {
        state._files[file_id] = {
            ...state._files[file_id],
            channel_id: event.channel_id,
            message_id: event.message_id,
            user_id: event.user_id,

        }
    }

    return state
}

const rejectedDescribeFileReducer: CaseReducer<NinchatState, DescribeFileRejectedAction> = (state, action) => {
    const {meta: {arg: {file_id}}} = action

    const {
        channel_id,
        message_id,
        user_id,
    } = state._files[file_id] ?? {}

    const id = channel_id ?? user_id

    const message = id ? state._messages[id]?.messages.find((m) => m.message_id === message_id) : undefined

    if (message) {
        message._revision = Date.now()
        message.files = (message.files ?? []).map((file) => {
            if (file.file_id !== file_id) {
                return file
            }

            return {
                ...file,
                error: action.payload,
            }
        })
    }
}
